var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialize)?_c('div',[(_vm.userLevel=='N4' || _vm.userLevel=='N5')?_c('top_n45'):(_vm.userLevel=='N3')?_c('top_n3'):(_vm.userLevel=='N2')?_c('top_n2'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }